<template>
  <div class="footer-nav">
    <div class="nav-left">
      <img :src="require('@/assets/img/footer/logo.png')" alt="">
    </div>

    <div class="nav-right">
      <div class="nav-right-links">
        <p class="font-weight-bold mb-2">聯絡我們</p>
        <ul>
          <li>
            <router-link
              :to="{ name: 'About' }"
            >
              關於守寫字
            </router-link>
          </li>
          <li>
            <a href="https://www.instagram.com/writes_tw/" target="_blank"><b-icon icon="instagram"></b-icon> writes_tw</a>
          </li>
          <li>
            <a href="https://www.facebook.com/ShowYourWords" target="_blank"><b-icon icon="facebook"></b-icon> 手寫字＆守寫字</a>
          </li>
        </ul>
      </div>

      <div class="nav-right-links">
        <p class="font-weight-bold mb-2">線上製作手寫字體</p>
        <ul>
          <template v-if="!isLoggedIn">
            <li>
              <router-link
                :to="{ name: 'Login' }"
              >
                登入
              </router-link>
            </li>
          </template>
          <template v-else>
            <li>
              <router-link
                :to="{ name: 'MemberCenter' }"
              >
                會員中心
              </router-link>
            </li>
          </template>
          <li>
            <router-link
              :to="{ name: 'Features' }"
            >
              服務特色
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'SaveHandwriting' }"
            >
              保存手寫字
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'HelpCenter' }"
            >
              說明中心
            </router-link>
          </li>
        </ul>
      </div>

      <div class="nav-right-links">
        <p class="font-weight-bold mb-2">實體產品</p>
        <ul>
          <li>
            <router-link
              :to="{ name: 'ReadingCalendar' }"
            >
              讀曆書店
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'WritingYear' }"
            >
              我寫的這一年
            </router-link>
          </li>
          <li>
            <router-link
              :to="{ name: 'YourWords' }"
            >
              你的字
            </router-link>
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: 'FooterNav',
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters('auth', ['hasToken']),
    isLoggedIn() {
      return this.hasToken;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
.footer-nav {
  display: flex;
  justify-content: space-between;

  letter-spacing: .2em;
  .nav-left {
    margin-bottom: 3rem;
    p {
      text-align: left;
      margin-bottom: .2rem;
    }
    img {
      width: 150px;
    }
  }

  ul, li {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  .nav-right {
    display: flex;
    column-gap: 4rem;
  }

  .nav-right-links {
    margin-bottom: 3rem;
    li {
      text-align: left;
      margin-bottom: .5rem;
      a {
        color: var(--main-dark);
      }
    }
  }


  @include smaller-than-medium() {
    display: block;
    .nav-left {
      text-align: center;
    }

    .nav-right {
      display: block;
      .nav-right-links {
        li, p {
          text-align: center;
        }
      }

    }
  }
}
</style>
